// yg-bundle-popup — exit-intent "Bundle & Save" modal trigger
(function () {
  var STORAGE_KEY = 'yg_exit_popup_seen';
  var popup = document.getElementById('yg-exit-popup');
  if (!popup) return;

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  var shown = false;
  function showPopup() {
    if (shown) return;
    shown = true;
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('mouseleave', function (e) {
    if (e.clientY < 10) showPopup();
  });

  var mobileTimer = setTimeout(function () {
    if (/Mobi|Android/i.test(navigator.userAgent)) showPopup();
  }, 30000);

  document.getElementById('yg-exit-close').addEventListener('click', closePopup);
  document.getElementById('yg-exit-overlay').addEventListener('click', closePopup);
  document.getElementById('yg-exit-dismiss').addEventListener('click', closePopup);

  document.addEventListener('click', function () { clearTimeout(mobileTimer); }, { once: true });
})();
